/**
 * this file is for inspector services linked to the field rep app, not the normal QA review process
 */

import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders, getToken } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/inspector/orders`;

export const createFormHeaderTemplate = async (orderLineId, formHeaderInfo) => {
  const url = `${baseRoute}/${orderLineId}/forms`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(formHeaderInfo),
  });

  let json = null;

  try {
    const parsedJson = await response.json();
    json = parsedJson;
  } catch (error) {
    // do nothing
  }

  return response.ok ? json : Promise.reject(response);
};

export const removeOrderFormHeaderById = async (orderLineId, orderFormHeaderId) => {
  const url = `${baseRoute}/${orderLineId}/forms/${orderFormHeaderId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
    body: JSON.stringify({
      orderFormHeaderId,
    }),
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getZippedImages = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/getImageExport`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  if (response.status !== 200) {
    throw response.statusText;
  }

  const blob = await response.blob();
  downloadData(blob, `bluesky_photos_${orderLineId}.zip`);
};

/** Inspector QA Review save new uploaded pictures  */
export const saveUploadedImages = async (orderForms, orderLineId, images = [], specifiedOrderFormHeaderId = null) => {
  let firstFormHeader = orderForms[0];
  if (orderForms.some(of => of.formHeaderName.includes('Primary'))) {
    firstFormHeader = orderForms.find(of => of.formHeaderName.includes('Primary'));
  }

  const { orderFormHeaderId } = firstFormHeader;

  //var formHeaderAnswerImages =
  let formData = new FormData();
  var photoData = [];

  images.forEach(img => {
    // const blob = new Blob([img]);

    formData.append('photos', img);

    let photoDataItem = { fileName: img.fileName, label: img.label };
    photoData.push(photoDataItem);
  });

  formData.append('photoData', JSON.stringify(photoData));

  try {
    const response = await fetch(
      baseRoute + `/${orderLineId}/formheader/${orderFormHeaderId}/images?processImmediately=true`,
      {
        method: 'POST',
        headers: {
          /*Accept: "application/json",
                    "Content-Type": "application/json",*/
          Accept: 'multipart/form-data',
          // 'Content-Type': 'multipart/form-data', //required for android pic
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      },
    );

    if (response.status != 200) {
      var newError = new Error(`${orderLineId}: ${response.text()}`);
      newError.name = 'PostImagesBadRequest';
      throw newError;
    } else {
      const uploadedImages = await response.json();
      return uploadedImages;
    }
  } catch (err) {
    if (err.name != 'PostImagesBadRequest') {
      err.message = `${orderLineId}: ${err.message}`;
    }
    throw err;
  }
};

/** Inspector QA Review save new uploaded pictures  */
export const saveUploadedImagesWarnDuplicates = async (orderForms, orderLineId, images = [], specifiedOrderFormHeaderId = null) => {
  let firstFormHeader = orderForms[0];
  if (orderForms.some(of => of.formHeaderName.includes('Primary'))) {
    firstFormHeader = orderForms.find(of => of.formHeaderName.includes('Primary'));
  }

  const { orderFormHeaderId } = firstFormHeader;

  //var formHeaderAnswerImages =
  let formData = new FormData();
  var photoData = [];

  images.forEach(img => {
    // const blob = new Blob([img]);

    formData.append('photos', img);

    let photoDataItem = { fileName: img.fileName, label: img.label };
    photoData.push(photoDataItem);
  });

  formData.append('photoData', JSON.stringify(photoData));

  try {
    const response = await fetch(
      baseRoute + `/${orderLineId}/formheader/${orderFormHeaderId}/images?processImmediately=true&warnDuplicates=true`,
      {
        method: 'POST',
        headers: {
          /*Accept: "application/json",
                    "Content-Type": "application/json",*/
          Accept: 'multipart/form-data',
          // 'Content-Type': 'multipart/form-data', //required for android pic
          Authorization: `Bearer ${getToken()}`,
        },
        body: formData,
      },
    );

    if (response.status != 200) {
      var newError = new Error(`${orderLineId}: ${response.text()}`);
      newError.name = 'PostImagesBadRequest';
      throw newError;
    } else {
      const uploadedImages = await response.json();
      return uploadedImages;
    }
  } catch (err) {
    if (err.name != 'PostImagesBadRequest') {
      err.message = `${orderLineId}: ${err.message}`;
    }
    throw err;
  }
};

export const updateFormAnswers = async (answers, orderLineId) => {
  const response = await fetch(baseRoute + `/${orderLineId}/answers`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(answers),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const saveForm = async (orderForms, orderLineId) => {
  var allOrderQuestions = [].concat.apply(
    [],
    orderForms.map(fo => fo.formQuestions),
  );
  initTriggeredSubs(allOrderQuestions, allOrderQuestions);

  var flattenedAnswers = [].concat.apply(
    [],
    allOrderQuestions.map(q => q.answers),
  );

  var results = await updateFormAnswers(flattenedAnswers, orderLineId);

  //set new formFieldRepAnswerId
  //TODO only if FormFieldRepAnswerId == 0
  allOrderQuestions.forEach(qtu => {
    var newAnswers = results.filter(
      r => qtu.questionId == r.questionId && qtu.orderFormHeaderId == r.orderFormHeaderId,
    );
    if (newAnswers.length > 0) {
      qtu.answers = newAnswers;
    }
  });

  return orderForms;
};

export const submitOrder = async orderLineId => {
  const response = await fetch(baseRoute + '/' + orderLineId + '/complete', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const PostRCTAnswers = async (rctAnswers, orderLineId) => {
  const url = `${baseRoute}/SaveRCTAnswers/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(rctAnswers),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const unstashOrder = async orderLineId => {
  const url = `${baseRoute}/${orderLineId}/unstash`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

// PRIVATE FUNCTIONS

// Solution for big files (source: https://stackoverflow.com/a/25975345/831138)
const downloadData = (data, filename) => {
  var textUrl = URL.createObjectURL(data);
  var element = document.createElement('a');
  element.setAttribute('href', textUrl);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

const initTriggeredSubs = (questions, orignalQuestions) => {
  //Performing with slice creates a copy of the original questions array just in case we pass in this.allOrderQuestions and it is self mutating
  questions.slice().forEach(q => {
    if (q.answers.length > 0) {
      var answerTriggerDefinition = q.answerTriggers.filter(at =>
        q.answers.some(a => a.answerValueId == at.answerValueId),
      );
      var triggeredSubs = null;
      if (answerTriggerDefinition.length > 0) {
        triggeredSubs = [].concat
          .apply(
            [],
            answerTriggerDefinition.map(q => q.triggeredSub),
          )
          .filter(x => x);
      }

      if (
        triggeredSubs != null &&
        triggeredSubs[0] != null &&
        triggeredSubs.filter(
          ts =>
            !!ts &&
            !orignalQuestions.some(
              pq => pq.formDefinitionId == ts.formDefinitionId && q.orderFormHeaderId == ts.orderFormHeaderId,
            ),
        ).length > 0
      ) {
        //filter triggered subs  already in questions:
        triggeredSubs = triggeredSubs.filter(
          ts =>
            !!ts &&
            !orignalQuestions.some(
              pq => pq.formDefinitionId == ts.formDefinitionId && q.orderFormHeaderId == ts.orderFormHeaderId,
            ),
        );
        var questionIndex = orignalQuestions.findIndex(
          pq => pq.formDefinitionId == q.formDefinitionId && q.orderFormHeaderId == pq.orderFormHeaderId,
        );
        orignalQuestions.splice(questionIndex + 1, 0, ...triggeredSubs);
        initTriggeredSubs(triggeredSubs, orignalQuestions);
      }
    }
  });
};

const groupBy = (xs, key) => {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const groupByArray = (xs, key) => {
  return xs.reduce(function(rv, x) {
    let v = key instanceof Function ? key(x) : x[key];
    let el = rv.find(r => r && r.key === v);
    if (el) {
      el.values.push(x);
    } else {
      rv.push({ key: v, values: [x] });
    }
    return rv;
  }, []);
};

export const addFormHeader = async (orderLineId, newFormHeader) => {
  const url = `${baseRoute}/${orderLineId}/forms`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(newFormHeader),
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};
